import type { FC, ReactNode } from 'react'

import { Layout } from '@/components/generals/layout'
import { Seo } from '@/components/generals/seo'
import { Hero } from '@/components/landing/hero'
import { Statement } from '@/components/landing/statement'
import { Approach } from '@/components/landing/approach'
import { WhyChoose } from '@/components/landing/why-choose'
import { SelectedWork } from '@/components/landing/selected-work'
import { Testimonials } from '@/components/landing/testimonials'
import { Mission } from '@/components/landing/mission'
import { Faq } from '@/components/contact/faq'
import { BlogPreview } from '@/components/landing/blog-preview'

const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo
                description='Northlight is the photography studio of Rowan Vale: portraiture, weddings, family sessions and commissions made in Edinburgh and across Scotland.'
                ogImage='/images/cap-hero.jpg'
            />

            <Hero />
            <Statement />
            <Approach />
            <WhyChoose />
            <SelectedWork />
            <Testimonials />
            <Mission />
            <Faq />
            <BlogPreview />
        </Layout>
    )
}

export default Home
